import React from "react";
import { IoIosArrowDown } from "react-icons/io";

export const Toggle = ({ enabled, toggleHandler, disabled }) => (
    <label css={{
        display: "flex",
        alignItems: "center",
        opacity: disabled ? .5 : 1,
    }}>
        <div css={{
            width: 45,
            height: 24,
            padding: 2,
            display: "flex",
            justifyContent: "center",
            borderRadius: 50,
            backgroundColor: enabled ? "var(--green)" : "rgba(100, 100, 100, .2)",
            boxShadow: "0px 0px 3px -2px black inset",
            transition: "background-color var(--transition-default-time) ease",
            cursor: disabled ? "not-allowed" : "pointer",
            ":hover": {
                backgroundColor: enabled ? "#34c759" : "rgba(100, 100, 100, .3)",
            },
            ":focus-within": {
                backgroundColor: enabled ? "#34c759" : "rgba(100, 100, 100, .3)",
            },
        }}>
            <div css={{
                width: 20,
                height: 20,
                borderRadius: 50,
                backgroundColor: "var(--light)",
                boxShadow: "0px 0px 3px -2px black",
                transform: enabled ? "translateX(10px)" : "translateX(-10px)",
                transition: "transform var(--transition-default-time) ease, background-color var(--transition-default-time) ease",
            }} />
        </div>
        <input
            disabled={ disabled }
            checked={ enabled }
            type="checkbox"
            css={{
                appearance: "none",
            }}
            onChange={ toggleHandler }
        />
    </label>
);

export const BaseDropdown = ({ options, selectKey, selectValue, value, setValue, placeholder, ...rest }) => (
    <div css={{
        width: "100%",
        display: "flex",
        alignItems: "center",
    }}>
        { /* eslint-disable-next-line jsx-a11y/no-onchange */ }
        <select
            value={ value ? value : "--placeholder" }
            css={{
                appearance: "none",
                flex: "auto",
                color: "inherit",
                backgroundColor: "transparent",
                border: "none",
                cursor: "pointer",
                paddingRight: 15,
                ":invalid": {
                    outline: 0,
                    boxShadow: "none",
                    border: "none",
                    color: "var(--red)",
                },
            }}
            onChange={ e => setValue(e.target.value) }
            { ...rest }
        >
            <option
                value="--placeholder"
                disabled={ true }
                css={{
                    color: "grey",
                    backgroundColor: "var(--dark)",
                }}
            >
                { placeholder || "Select" }
            </option>

            {
                Object.keys(options).map(option =>
                    <option
                        key={ option }
                        value={ selectValue === "key" ? option : selectValue === "keyvalue" ? option + " (" + options[option] + ")" : options[option] }
                        css={{
                            backgroundColor: "var(--dark)",
                        }}
                    >
                        { selectKey === "value" ? options[option] : selectKey === "keyvalue" ? option + " (" + options[option] + ")" : option }
                    </option>
                )
            }
        </select>

        <IoIosArrowDown css={{
            marginLeft: -15,
            pointerEvents: "none",
        }} />
    </div>
);

const AbstractInput = ({ type, title, description, pretext, placeholder, value, setValue, ...rest }) => (
    <div css={{
        marginBottom: 15,
        padding: 10,
        backgroundColor: "rgba(100, 100, 100, .2)",
        borderRadius: 3,
        transition: "background-color var(--transition-default-time) ease-out",
        ":hover": {
            backgroundColor: "rgba(100, 100, 100, .3)",
        },
        ":focus-within": {
            backgroundColor: "rgba(100, 100, 100, .3)",
        },
    }}>
        <div css={{
            marginBottom: 0,
            color: "rgba(200, 200, 200, .5)",
            fontSize: ".7em",
            fontWeight: 500,
            textTransform: "uppercase",
        }}>
            { title }
        </div>
        <div css={{
            marginBottom: 5,
            color: "rgba(200, 200, 200, .3)",
            fontSize: ".6em",
            fontWeight: 500,
        }}>
            { description }
        </div>
        <div css={{
            display: "flex",
            alignItems: "center",
            fontSize: ".8em",
        }}>
            {
                pretext
                ?   <div css={{
                        marginRight: 5,
                        color: "lightgrey",
                    }}>
                        { pretext }
                    </div>
                :   null
            }
            <input
                type={ type }
                placeholder={ placeholder }
                value={ value }
                css={{
                    flex: "auto",
                    backgroundColor: "transparent",
                    border: "none",
                    ":disabled": {
                        color: "darkgrey",
                    },
                    ":invalid": {
                        outline: 0,
                        boxShadow: "none",
                        border: "none",
                        color: "var(--red)",
                    },
                }}
                onChange={ e => setValue(e.target.value) }
                { ...rest }
            />
        </div>
    </div>
);

export const Text = (props) => (
    <AbstractInput
        type="text"
        { ...props }
    />
);

export const URL = (props) => (
    <AbstractInput
        type="url"
        { ...props }
    />
);

export const Email = (props) => (
    <AbstractInput
        type="email"
        { ...props }
    />
);

export const Phone = (props) => (
    <AbstractInput
        type="tel"
        { ...props }
    />
);

export const Dropdown = ({ title, description, pretext, placeholder, ...rest }) => (
    <div css={{
        marginBottom: 15,
        padding: 10,
        backgroundColor: "rgba(100, 100, 100, .2)",
        borderRadius: 3,
        transition: "background-color var(--transition-default-time) ease-out",
        ":hover": {
            backgroundColor: "rgba(100, 100, 100, .3)",
        },
        ":focus-within": {
            backgroundColor: "rgba(100, 100, 100, .3)",
        },
    }}>
        <div css={{
            marginBottom: 0,
            color: "rgba(200, 200, 200, .5)",
            fontSize: ".7em",
            fontWeight: 500,
            textTransform: "uppercase",
        }}>
            { title }
        </div>
        <div css={{
            marginBottom: 5,
            color: "rgba(200, 200, 200, .3)",
            fontSize: ".6em",
            fontWeight: 500,
        }}>
            { description }
        </div>
        <div css={{
            display: "flex",
            alignItems: "center",
            fontSize: ".8em",
        }}>
            {
                pretext
                ?   <div css={{
                        marginRight: 5,
                        color: "lightgrey",
                    }}>
                        { pretext }
                    </div>
                :   null
            }
            <BaseDropdown
                placeholder={ placeholder }
                { ...rest }
            />
        </div>
    </div>
);
